import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";

type StatTone = "default" | "primary";

const STAT_TONES: Record<StatTone, { bg: string; border: string; accent: string }> = {
  default: { bg: "smBackgroundSecondary", border: "smBorder", accent: "smMuted" },
  primary: { bg: "smPrimarySofter", border: "smPrimarySoft", accent: "smPrimary" },
};

interface Props {
  icon: IconType;
  label: string;
  value: string;
  tone?: StatTone;
  mono?: boolean;
  pending?: boolean;
}

export const HeaderStat = ({ icon, label, value, tone = "default", mono = false, pending = false }: Props) => {
  const colors = STAT_TONES[tone];
  return (
    <Box
      bg={colors.bg}
      border="1px solid"
      borderColor={colors.border}
      rounded="lg"
      px="4"
      py="3"
      opacity={pending ? 0.55 : 1}
    >
      <HStack spacing="2" mb="1.5">
        <Icon as={icon} boxSize="3.5" color={colors.accent} />
        <Text fontSize="xs" fontWeight="bold" letterSpacing="wider" textTransform="uppercase" color={colors.accent}>
          {label}
        </Text>
      </HStack>
      <Text fontSize="lg" fontWeight="bold" color="smText" noOfLines={1} fontFamily={mono ? "mono" : undefined}>
        {value}
      </Text>
    </Box>
  );
};
